import React from "react";
import LearnMore from "../../../../../components/learnMore/learnMore";

const LifeTimeValueLearnText = () => {
  return (
    <LearnMore
      title="Lifetime Value (LTV) by Membership Type"
      content={getContent()}
      html
    />
  );
};

const getContent = () => {
  return `
  This module will show you how much revenue each Membership Type has generated. All clients are grouped together by
   their membership type. If a client has held multiple membership types while with your business, the revenue generated
    while holding the specific membership type will only be attributed to that membership type. The same client can 
    contribute to different membership types. 
  <br />
  <br />
  <b>Membership Type:</b> This filter will display your membership types. You can select all, a single agreement or multiple. 
  </br> 
  </br> 
    <b>Date Range:</b> Select from preset date ranges. 
  </br>
  </br> 
    <b>Date:</b> Specify start and end date.
  </br>
  </br> 
    <b>Total:</b> Depending your filters above, this is the total amount of revenue that the membership types have
     contributed to your business. Note that iKizmet may not be pulling in all your historical data into the dashboard.   
  </br>
  </br> 
    <b>Totally Monthly:</b> Total amount of revenue per month over the time selected.   
  </br>
  </br> 
    <b>Average By Member:</b> The average amount of revenue each member over the time selected.
  </br>
  </br> 
    <b>Average Monthly By Member:</b> The monthly average amount of revenue each member over the time selected.
  </br>
  </br> 
    <b>Pie Chart:</b> Visual representation of each membership types revenue the total. </br>
    <i>Only the top seven types will be shown in their own slice. Anything over eight will be lumped into the Other slice.</i>
  </br>
  </br> 
  </br> 
    <b>Table:</b>
  </br>
    iKizmet will show each agreement on a single line with some key metrics.
  </br>
   <b>Membership Type</b> will match the filter above.
  </br>
   <b>Membership LTV</b> is the amount of membership specific revenue that this membership type has contributed. Will not include non-membership nor product revenue. 
  </br>
   <b>Non-Membership LTV</b> is the amount of non-membership specific revenue that this membership type has contributed. Will not include membership nor product revenue.
  </br>
   <b>Product LTV</b> is the amount of product specific revenue that this membership type has contributed. Will not include membership nor non-membership revenue.
  </br>
   <b>Total LTV</b> is the amount of all revenue revenue that this membership type has contributed. This will include membership, non-membership and product revenue.
  </br>
   <b>Members Count</b> we will count the number of Members who contributed revenue for this membership type.
  </br>
   <b>Average By Member</b> is the average amount of revenue each member.
  </br>
   <b>Average Monthly By Member</b> is the monthly average amount of revenue each member.
  </br>
`;
};

export default LifeTimeValueLearnText;
